export const problems = [
  { code: 1, label: "1、如果您指向房间内的某样东西，孩子会看它吗?(例如，您指着一个玩具或一只动物，孩子会看这个玩具或这只动物吗?)"},
  { code: 2, label: "2、您怀疑过孩子的听力有障碍(耳聋)吗?"},
  { code: 3, label: "3、您的孩子会玩假装游戏吗?(例如,假装从空的杯子中喝水，假装打电话，假装喂娃娃或毛绒玩具?)" },
  { code: 4, label: "4、您的孩子喜欢爬上爬下吗?(如:家具、游乐场设施、或楼梯)" },
  { code: 5, label: "5、您的孩子会在自己眼睛附近做一些奇怪的手指活动吗?(例如， 您的孩子会在眼睛前摆动手指吗?)" },
  { code: 6, label: "6、您的孩子会用一根手指指东西表示需要或寻求帮助吗?(例如，指着他/她够不到的一块点心或玩具)" },
  { code: 7, label: "7、您的孩子会用一根手指指东西，向您展示有趣的东西吗?(例如，指向天空中的飞机或马路上的卡车)" },
  { code: 8, label: "8、您的孩子对其他孩子感兴趣吗?(例如，您的孩子会看其他孩子，对他们笑，走向他们吗?)" },
  { code: 9, label: "9、您的孩子会把东西拿给您，或举着东西给您看吗?不是寻求帮助，而只是分享。(例如，给您看花、毛绒玩具动物或玩具卡车)"},
  { code: 10, label: "10、您叫孩子名字的时候，他/她会有反应吗?(例如，您叫他/她的名字，他她会抬头看、说话或发出咿呀声、或者停下正在做的事 吗?)" },
  { code: 11, label: "11、您对您的孩子笑的时候，他/她也会对您笑吗?" },
  { code: 12, label: "12、您的孩子会因为日常噪音而感到不安吗? (例如，您的孩子会因为电吹风或高分贝音乐而尖叫或哭闹吗?)" },
  { code: 13, label: "13、您的孩子会走路了吗?" },
  { code: 14, label: "14、当您跟孩子说话、玩耍或穿衣服时他/她会与您对视吗?"},
  { code: 15, label: "15、您的孩子会模仿您做的事吗?(例如，挥手再见、鼓掌或者发出有趣的声音)" },
  { code: 16, label: "16、如果您转头看某样东西，您的孩子会转过头来试图了解您在看什么吗?" },
  { code: 17, label: "17、您的孩子会试图让您去看他/她吗?(例如，您的孩子会看着您等待夸奖!或者说“看”、“看我”吗?)"},
  { code: 18, label: "18、当您告诉您的孩子去做某事时，他/她能理解吗?(例如，如果您不用手指，您的孩子能理解“把书放在椅子上”或“给我拿拖鞋”吗?)" },
  { code: 19, label: "19、如果发生了新鲜事，您的孩子会看您的脸去观察您的反应吗?(例如，如果他/她听到了奇怪或有趣的声音或看到了新玩具，他/她会看您的脸吗?)" },
  { code: 20, label: "20、您的孩子喜欢被摇晃吗?(例如,在您的膝盖上摇晃或弹跳)" },
]
export const  defaultValues = {
  value1: "",
  value2: "",
  value3: "",
  value4: "",
  value5: "",
  value6: "",
  value7: "",
  value8: "",
  value9: "",
  value10: "",
  value11: "",
  value12: "",
  value13: "",
  value14: "",
  value15: "",
  value16: "",
  value17: "",
  value18: "",
  value19: "",
  value20: "",
}

export const answers=[
  {code: 1, value: "是"},
  {code: 2, value: "否"},
]

export const visitProblems = [
  { code: 1, label: "1、您的孩子喜欢被您放在膝上做摇摆、蹦跳之类的事情吗?"},
  { code: 2, label: "2、您的孩子对其他孩子有兴趣吗?"},
  { code: 3, label: "3、您的孩子喜欢爬上爬下,像上楼梯吗?" },
  { code: 4, label: "4、您的孩子喜欢藏猫猫或者捉迷藏的游戏吗?" },
  { code: 5, label: "5、您的孩子会假装做事吗?如:打电话或照顾洋娃娃,或者假装其他别的事情?" },
  { code: 6, label: "6、您的孩子曾用食指指着东西,要求要某样东西吗? " },
  { code: 7, label: "7、您的孩子曾用食指指着东西,表示对某样东西有兴趣吗? " },
  { code: 8, label: "8、您的孩子会正确玩小玩具(例如车子或积木),而不是把它们放在嘴里、随便乱动或是把它们丢掉?" },
  { code: 9, label: "9、您的孩子曾经拿东西给您(父母)看吗?"},
  { code: 10, label: "10、您的孩子看着您的眼睛超过一、两秒吗?" },
  { code: 11, label: "11、您的孩子曾经看起来像对噪音特别敏感吗(比如捂住耳朵)?" },
  { code: 12, label: "12、您的孩子看着您的脸或者您的笑容时,会以微笑回应吗?" },
  { code: 13, label: "13、您的孩子会模仿您吗?(例如您做鬼脸,您的孩子也会模仿吗?" },
  { code: 14, label: "14、当您叫孩子的名字时,他(她)会有反应吗?"},
  { code: 15, label: "15、如果您指着房间另一头的玩具,您的孩子会看那个玩具吗?" },
  { code: 16, label: "16、您的孩子会走路吗?" },
  { code: 17, label: "17、您的孩子会看您正在看的东西吗?"},
  { code: 18, label: "18、您的孩子会在他(她)的脸附近做一些不同寻常的手指动作吗?" },
  { code: 19, label: "19、您的孩子会设法吸引您看他(她)自己的活动吗?" },
  { code: 20, label: "20、您是否曾经怀疑您的孩子听力有问题?" },
  { code: 21, label: "21、您的孩子理解别人说的话吗?" },
  { code: 22, label: "22、您的孩子有时候会无目标地凝视或者无目的地走来走去吗?" },
  { code: 23, label: "23、您的孩子碰到不熟悉的事物时会看着您的脸,看看您的反应吗?" },
]

export const visitDefaultValues = {
  value1: "",
  value2: "",
  value3: "",
  value4: "",
  value5: "",
  value6: "",
  value7: "",
  value8: "",
  value9: "",
  value10: "",
  value11: "",
  value12: "",
  value13: "",
  value14: "",
  value15: "",
  value16: "",
  value17: "",
  value18: "",
  value19: "",
  value20: "",
  value21: "",
  value22: "",
  value23: "",
}

export const visitAnswers=[
  {code: 1, value: "从不"},
  {code: 2, value: "偶尔"},
  {code: 3, value: "有时"},
  {code: 4, value: "经常"},
]

